/* ==========================================================================
   ProductCardPackages > client > Config
   ========================================================================== */
const configuration = {
    init: true,
    initModal: false,
    initSearcher: false,
    selector: '[data-component="ProductCardPackages"]',
    type: {
        modal: 'product-card-modal',
        searcher: 'searcher-modal',
        imageTripadvisor: 'product-card-pak-image-tripadvisor'
    },
    css: {
        base: 'product-card-packages',
        soldOut: 'product-card-packages--sold-out',
        imageTripadvisor: 'image-rxjs--tripadvisor'
    },
    onOpenModal: () => {},
    onCloseModal: () => {}
};

const config = () => configuration;

module.exports = config;
